import { GenericAbortSignal } from 'axios';

import { DenialListItem } from 'models/DenialListItem';
import { Paginated } from 'models/Paginated';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export type AdminDenialListItemsIndexParams = BaseIndexQueryParams;

export const adminDenialListItemQueryKeys = {
  base: ['adminDenialListItems'],
  index: (denialListId: string, params: Record<string, any> = {}) => [
    'adminDenialListItems',
    'index',
    denialListId,
    params,
  ],
};

export async function indexAdminDenialListItems(
  denialListId: string,
  params: AdminDenialListItemsIndexParams,
  signal?: GenericAbortSignal
) {
  return http
    .get<Paginated<DenialListItem>>(`/admin/denial_lists/${denialListId}/denial_list_items`, { params, signal })
    .then((response) => response.data);
}
